import { TapeMeasureIcon } from './TapeMeasureIcon';

/**
 * author: GreenTurtwig
 * id C9C3F657-65A6-418E-91EF-E6FD8F0357C1
 * name tape-measure
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tape-measure.svg
 * tags
 * - Hardware / Tools 
 */
export const MeasuringTapeIcon = TapeMeasureIcon;
export default MeasuringTapeIcon